import {
  GraphsFbAndIg,
  InsightQueryFbResponse,
  Insights,
  QueryFbComment,
  Status,
} from "../types/campaigns";
import { ENV } from "../utils/constants";
import {
  price,
  translateStatusPaidFacebook,
  translateStatusSocialNetworks,
} from "../utils/format";
import api from "./api";

export const getMetricsFacebookAds = async () => {
  const response = await api.get(`/advertising-dashboard-${ENV}/ads/findMetrics`);
  return response?.data?.content;
};

export const getMetricsFacebook = async () => {
  const response = await api.get(`/advertising-dashboard-${ENV}/metrics/facebook`);
  return response?.data?.content;
};

export const getStatusFacebook = async (
  campaign_id: string | number
): Promise<Status[]> => {
  const response = await api.post(
    `social-networks-v2-${ENV}/insights/facebook`,
    { campaign_id }
  );

  if (response.data?.content.insights.comments_count > 0) {
    await api.post(`social-networks-v2-${ENV}/comments/facebook`, {
      campaign_id,
    });
  }

  delete response.data?.content.insights.fb_post_id;
  delete response.data?.content.insights.page_post_engagements;

  const status = Object.entries(response.data?.content.insights).map(
    (value) => ({
      quantidade: value[1],
      status_envio_externo: translateStatusSocialNetworks(value[0]),
    })
  );

  return status;
};

export const getInsightsPaidFacebook = async (
  ads_id: string | number,
  creative_id: string | number
): Promise<Insights[]> => {
  const content = await api.get(
    `/ads-manager-${ENV}/ads/insights/${ads_id}/${creative_id}`,
    {}
  );

  delete content.data?.content.overview.account_currency;
  delete content.data?.content.overview.cost_per_inline_post_engagement;
  delete content.data?.content.overview.cost_per_unique_click;
  delete content.data?.content.overview.cpc;
  delete content.data?.content.overview.cpm;
  delete content.data?.content.overview.cpp;
  delete content.data?.content.overview.date_start;
  delete content.data?.content.overview.date_stop;
  delete content.data?.content.overview.spend;
  delete content.data?.content.overview.cost_per_inline_link_click;
  let overview = content.data?.content.overview;

  overview.frequency = price(overview.frequency);

  let age = content.data?.content.age;
  let device = content.data?.content.device;
  let gender = content.data?.content.gender;
  let platforms = content.data?.content.platforms;

  const status = Object.entries(content.data?.content.overview).map(
    (value) => ({
      quantidade: value[1],
      status_envio_externo: translateStatusPaidFacebook(value[0]),
      age,
      device,
      gender,
      platforms,
    })
  );
  return status;
};

export const getGraphsFacebookCommentsData = async (): Promise<
  GraphsFbAndIg[]
> => {
  const { data } = await api.get(
    `/advertising-dashboard-${ENV}/metrics/count/facebook-comments`,
    {}
  );

  return data?.content;
};

export const getGraphsFacebookLikesData = async (): Promise<
  GraphsFbAndIg[]
> => {
  const { data } = await api.get(
    `/advertising-dashboard-${ENV}/metrics/count/facebook-likes`,
    {}
  );

  return data?.content;
};

export const getGraphsFacebookViewsData = async (): Promise<
  GraphsFbAndIg[]
> => {
  const { data } = await api.get(
    `/advertising-dashboard-${ENV}/metrics/count/facebook-views`,
    {}
  );

  return data?.content;
};

export const getGraphsFacebookEngajamentData = async (): Promise<
  GraphsFbAndIg[]
> => {
  const { data } = await api.get(
    `/advertising-dashboard-${ENV}/metrics/count/facebook-engajament`,
    {}
  );

  return data?.content;
};

export const getGraphsFacebookUniqueViewsData = async (): Promise<
  GraphsFbAndIg[]
> => {
  const { data } = await api.get(
    `/advertising-dashboard-${ENV}/metrics/count/facebook-unique-views`,
    {}
  );

  return data?.content;
};

export const getGraphsFacebookPaidViewsData = async (): Promise<
  GraphsFbAndIg[]
> => {
  const { data } = await api.get(
    `/advertising-dashboard-${ENV}/metrics/count/facebook-paid-views`,
    {}
  );

  return data?.content;
};

export const getPerformanceFacebook = async (
  campaign_id: string | number
): Promise<InsightQueryFbResponse | any > => {
  const {
    data: { content },
  } = await api.post(`/social-networks-v2-${ENV}/insights/facebook`, {
    campaign_id,
  });

  console.log("service fb - content", content);

  return content;
};

export const getCommentsFacebook = async (
  campaign_id: string | number
): Promise<QueryFbComment> => {
  const content = await api.post(
    `/social-networks-v2-${ENV}/comments/facebook`,
    {
      campaign_id,
    }
  );

  return content.data.content;
};
